import React, { useState } from 'react';
import LinkButton from '../../../Components/Button/LinkButton';
import { TreatmentFormModalContextKeys } from '../../../Components/Treatment/TreatmentFormModalContextKeys';
import ModalCloseConfirmation from '../../Modal/Components/ModalCloseConfirmation';
import { useModalContext } from '../../Modal/Services/ModalContext';
import { Theme } from '../../../Enums/Theme.enum';

interface Props {
	onClose?: () => void;
}

const ElectronicPrescriptionCloseButton: React.FC<Props> = ({ onClose }) => {
	const { checkIfModalCanBeClosedByKeys } = useModalContext();
	const [isCloseConfirmationOpen, setIsCloseConfirmationOpen] = useState(false);

	const handleOnClose = () => {
		checkIfModalCanBeClosedByKeys([
            TreatmentFormModalContextKeys.PRESCRIPTION_STEP_1,
            TreatmentFormModalContextKeys.PRESCRIPTION_STEP_2_MEDICAMENT_LIST,
            TreatmentFormModalContextKeys.PRESCRIPTION_STEP_3
        ])
			? onClose?.()
			: setIsCloseConfirmationOpen(true);
	};

	return (
		<>
			<LinkButton
				title={'base.shared.close'}
				theme={Theme.RED}
				onClick={handleOnClose}
			/>
			{isCloseConfirmationOpen && (
				<ModalCloseConfirmation
					isOpen={isCloseConfirmationOpen}
					onReject={() => setIsCloseConfirmationOpen(false)}
					onConfirm={() => onClose?.()}
				/>
			)}
		</>
	);
};

export default ElectronicPrescriptionCloseButton;
